import { render, staticRenderFns } from "./SkupTema2Edit.vue?vue&type=template&id=72f834aa&scoped=true&"
import script from "./SkupTema2Edit.vue?vue&type=script&lang=js&"
export * from "./SkupTema2Edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f834aa",
  null
  
)

export default component.exports